// import { gsap } from 'gsap';

let ellipseRotationTL, imgRotationTL, imgSecondRotationTL;

window.firstGradientGSAPAnimation = function firstGradientGSAPAnimation() {
  const imgContainer = document.querySelector(
    '.first-sec-bg__bg-decor-ellipses'
  );
  const main = document.querySelector('.main');

  if (!imgContainer || !main) return;

  if (window.innerWidth > 1024) {
    imgContainer.getBoundingClientRect();

    requestAnimationFrame(() => {
      const img = imgContainer.querySelector(
        '.first-sec-bg__bg-decor-ellipse-img-wr:nth-child(1) .first-sec-bg__bg-decor-ellipse-img'
      );
      const imgSecond = imgContainer.querySelector(
        '.first-sec-bg__bg-decor-ellipse-img-wr:nth-child(2) .first-sec-bg__bg-decor-ellipse-img'
      );

      gsap.set(imgContainer, {
        xPercent: 0,
        yPercent: -50,
        x: 0,
        y: 0,
        transformOrigin: 'center center',
      });

      ellipseRotationTL = gsap.to(imgContainer, {
        rotation: 360,
        ease: 'none',
        repeat: -1,
        duration: 30,
      });

      imgRotationTL = gsap.to(img, {
        rotation: -360,
        ease: 'none',
        repeat: -1,
        duration: 30,
      });

      imgSecondRotationTL = gsap.to(imgSecond, {
        rotation: 360,
        ease: 'none',
        repeat: -1,
        duration: 40,
      });
    });
  }
};

window.pauseFirstGradientAnimation = function pauseFirstGradientAnimation() {
  if (window.innerWidth > 1024) {
    ellipseRotationTL?.pause();
    imgRotationTL?.pause();
    imgSecondRotationTL?.pause();
  }
};

window.resumeFirstGradientAnimation = function resumeFirstGradientAnimation() {
  if (window.innerWidth > 1024) {
    ellipseRotationTL?.play();
    imgRotationTL?.play();
    imgSecondRotationTL?.play();
  }
};

firstGradientGSAPAnimation();
